import { PasswordStrength, PASSWORD_STRENGTH_TEXT_MAP } from '@/constants/enum';
import { Rule } from 'antd/lib/form';
import { i18n } from "@/locales";
/**
 * 数字，英文字符，特殊符号
 */
const SYMBOL_TYPE_PATTERNS = [/\d+/, /[a-zA-Z]/, /[-!$%^&*()_+|~=`{}[\]:";'<>?,./]/];
/**
 * 获取字符类型种类数量
 */
export const getSymbolTypeLength = (pwd: string) => {
	return SYMBOL_TYPE_PATTERNS.map(pattern => pattern.test(pwd)).filter(item => item).length;
};
export const getPasswordValidate = (strength: PasswordStrength): Rule[] => {
	const required = {
		required: true,
		message: i18n.t("common.noEmptyPassword")
	};

	const validateMap: Record<PasswordStrength, Rule[]> = {
		[PasswordStrength.NoCheck]: [required],
		[PasswordStrength.Low]: [
			required,
			{
				validator(r, v) {
					if (v && v.length < 6) {
						return Promise.reject(PASSWORD_STRENGTH_TEXT_MAP[PasswordStrength.Low].validateMessage);
					}
					return Promise.resolve();
				}
			}
		],
		[PasswordStrength.Middle]: [
			required,
			{
				validator(r, v) {
					if (v && (v.length < 6 || getSymbolTypeLength(v) < 2)) {
						return Promise.reject(PASSWORD_STRENGTH_TEXT_MAP[PasswordStrength.Middle].validateMessage);
					}
					return Promise.resolve();
				}
			}
		],
		[PasswordStrength.High]: [
			required,
			{
				validator(r, v) {
					if (v && (v.length < 6 || getSymbolTypeLength(v) < 3)) {
						return Promise.reject(PASSWORD_STRENGTH_TEXT_MAP[PasswordStrength.High].validateMessage);
					}
					return Promise.resolve();
				}
			}
		],
		[PasswordStrength.AUTO]: [
			required,
			{
				pattern: window.__config__.customPasswordStrength.regex,
				message: window.__config__.customPasswordStrength.message
			}
		]
	};

	return validateMap[strength];
};

/**
 * 手机号非严谨
 * */
export const PHONE_RULES = /^(?:(?:\+|00)86)?1\d{10}$/;

/**
 * 电子邮箱
 */
export const EMAIL =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
